import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  Typography,
  Button,
  IconButton,
  Grid,
  MenuItem,
  TextField,
  Switch,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import _ from "lodash";
import { useFormik } from "formik";
import * as yup from "yup";
import dayjs from "dayjs";
import { CUSTOM_CONSTANTS } from "Constants";

// Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";

// Services
import servicefaretypeapi from "Services/Servicefare";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Servicetypecreate = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );
  const [servicedetails, setservicedetails] = useState([]);

  // Get Services list api
  const getServicetype = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setservicedetails(res?.data?.data?.data?.services || []);
      } else {
        setservicedetails([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    servicefaretypeapi.getexcludedServicesList().then(onSuccess, onFailure);
  }, [dispatch]);

  useEffect(() => {
    openDialog && getServicetype();
  }, [openDialog, getServicetype]);

  const formatTime = (time) => {
    if (time && dayjs.isDayjs(time)) {
      return time.format("hh:mm:ss A");
    }
    return null;
  };

  const handleAddServicefare = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const payload = {
      ...formValues,
      Daystartingtime: formValues.daystartingtime ? formatTime(formValues.daystartingtime) : null,
      Nightstartingtime: formValues.nightstartingtime ? formatTime(formValues.nightstartingtime) : null,
      Dayendingtime: formValues.dayendingtime ? formatTime(formValues.dayendingtime) : null,
      Nightendingtime: formValues.nightendingtime ? formatTime(formValues.nightendingtime) : null,
      DaystartingtimeWeekend: formValues.daystartingtimeWeekend ? formatTime(formValues.daystartingtimeWeekend) : null,
      NightstartingtimeWeekend: formValues.nightstartingtimeWeekend ? formatTime(formValues.nightstartingtimeWeekend) : null,
      DayendingtimeWeekend: formValues.dayendingtimeWeekend ? formatTime(formValues.dayendingtimeWeekend) : null,
      NightendingtimeWeekend: formValues.nightendingtimeWeekend ? formatTime(formValues.nightendingtimeWeekend) : null,
      SurgeHouronestartingTime: formValues.surgeHouronestartingTime ? formatTime(formValues.surgeHouronestartingTime) : null,
      SurgerHourtwostartingTime: formValues.surgerHourtwostartingTime ? formatTime(formValues.surgerHourtwostartingTime) : null,
      SurgeHouroneendingTime: formValues.surgeHouroneendingTime ? formatTime(formValues.surgeHouroneendingTime) : null,
      SurgerHourtwoendingTime: formValues.surgerHourtwoendingTime ? formatTime(formValues.surgerHourtwoendingTime) : null,
      dayRange: "MONDAY-SUNDAY",
      demoaccount_id: demoaccount_id,
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Service Fare Created Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while creating service fare",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    servicefaretypeapi.addservicefare(payload).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      servicetypes: "",
      surgeHourone: false,
      surgeHourtwo: false,
      isActive: true,
      daystartingtime: null,
      nightstartingtime: null,
      dayendingtime: null,
      nightendingtime: null,
      daystartingtimeWeekend: null,
      nightstartingtimeWeekend: null,
      dayendingtimeWeekend: null,
      nightendingtimeWeekend: null,
      daybaseprice: "",
      nightbaseprice: "",
      daybasepriceWeekend: "",
      nightbasepriceWeekend: "",
      daydistanceprice: "",
      nightdistanceprice: "",
      daydistancepriceWeekend: "",
      nightdistancepriceWeekend: "",
      dayminuteprice: "",
      nightminuteprice: "",
      dayminutepriceWeekend: "",
      nightminutepriceWeekend: "",
      surgeHouronestartingTime: null,
      surgerHourtwostartingTime: null,
      surgeHouroneendingTime: null,
      surgerHourtwoendingTime: null,
      surgeHouronepercentage: "",
      surgerHourtwopercentage: "",
      FreeTripWaitingMinuteday: "",
      FreeTripWaitingMinutenight: "",
      WaitingPriceperminday: "",
      WaitingPriceperminnight: "",
      FreeStopsWaitingperminday: "",
      FreeStopsWaitingperminnight: "",
      StopWaitingPriceperminday: "",
      StopWaitingPriceperminnight: "",
      FreeTripWaitingMinutedayWeekend: "",
      FreeTripWaitingMinutenightWeekend: "",
      WaitingPricepermindayWeekend: "",
      WaitingPriceperminnightWeekend: "",
      FreeStopsWaitingpermindayWeekend: "",
      FreeStopsWaitingperminnightWeekend: "",
      StopWaitingPricepermindayWeekend: "",
      StopWaitingPriceperminnightWeekend: "",
    },
    validationSchema: yup.object({
      servicetypes: yup.string().required("Service Type is required").nullable(),
      daystartingtime: yup.string().required("Day starting time is required").nullable(),
      nightstartingtime: yup.string().required("Night starting time is required").nullable(),
      dayendingtime: yup.string().required("Day ending time is required").nullable(),
      nightendingtime: yup.string().required("Night ending time is required").nullable(),
      daystartingtimeWeekend: yup.string().required("Day starting time is required").nullable(),
      nightstartingtimeWeekend: yup.string().required("Night starting time is required").nullable(),
      dayendingtimeWeekend: yup.string().required("Day ending time is required").nullable(),
      nightendingtimeWeekend: yup.string().required("Night ending time is required").nullable(),
      daybaseprice: yup.number().typeError("Must be a number").required("Required"),
      nightbaseprice: yup.number().typeError("Must be a number").required("Required"),
      daydistanceprice: yup.number().typeError("Must be a number").required("Required"),
      nightdistanceprice: yup.number().typeError("Must be a number").required("Required"),
      dayminuteprice: yup.number().typeError("Must be a number").required("Required"),
      nightminuteprice: yup.number().typeError("Must be a number").required("Required"),
      FreeTripWaitingMinuteday: yup.number().typeError("Must be a number").required("Required"),
      FreeTripWaitingMinutenight: yup.number().typeError("Must be a number").required("Required"),
      WaitingPriceperminday: yup.number().typeError("Must be a number").required("Required"),
      WaitingPriceperminnight: yup.number().typeError("Must be a number").required("Required"),
      FreeStopsWaitingperminday: yup.number().typeError("Must be a number").required("Required"),
      FreeStopsWaitingperminnight: yup.number().typeError("Must be a number").required("Required"),
      StopWaitingPriceperminday: yup.number().typeError("Must be a number").required("Required"),
      StopWaitingPriceperminnight: yup.number().typeError("Must be a number").required("Required"),
      daybasepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      nightbasepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      daydistancepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      nightdistancepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      dayminutepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      nightminutepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      FreeTripWaitingMinutedayWeekend: yup.number().typeError("Must be a number").required("Required"),
      FreeTripWaitingMinutenightWeekend: yup.number().typeError("Must be a number").required("Required"),
      WaitingPricepermindayWeekend: yup.number().typeError("Must be a number").required("Required"),
      WaitingPriceperminnightWeekend: yup.number().typeError("Must be a number").required("Required"),
      FreeStopsWaitingpermindayWeekend: yup.number().typeError("Must be a number").required("Required"),
      FreeStopsWaitingperminnightWeekend: yup.number().typeError("Must be a number").required("Required"),
      StopWaitingPricepermindayWeekend: yup.number().typeError("Must be a number").required("Required"),
      StopWaitingPriceperminnightWeekend: yup.number().typeError("Must be a number").required("Required"),
    }),
    enableReinitialize: true,
    onSubmit: handleAddServicefare,
  });

  const renderTimePicker = (name, value) => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        ampm={true}
        value={value}
        onChange={(newValue) => formik.setFieldValue(name, newValue)}
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            variant: "outlined",
            className: classes.inputShape,
            error: Boolean(formik?.errors?.[name] && formik?.touched?.[name]),
            helperText: formik?.touched?.[name] && formik?.errors?.[name],
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            fullWidth
            variant="outlined"
            className={classes.inputShape}
            error={Boolean(formik?.errors?.[name] && formik?.touched?.[name])}
            helperText={formik?.touched?.[name] && formik?.errors?.[name]}
          />
        )}
      />
    </LocalizationProvider>
  );

  const renderTextField = (name, placeholder = "0.00") => (
    <TextField
      name={name}
      id={name}
      placeholder={placeholder}
      value={formik?.values?.[name]}
      onChange={formik.handleChange}
      error={Boolean(formik?.errors?.[name] && formik?.touched?.[name])}
      helperText={formik?.touched?.[name] && formik?.errors?.[name]}
      fullWidth
      variant="outlined"
      size="small"
      className={classes.inputShape}
    />
  );

  const handleModalClose = () => {
    formik.resetForm();
    handleClose();
  };

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleModalClose}
      maxWidth="lg"
      className={classes.root}
    >
      {/* Header */}
      <DialogTitle className={classes.dialogTitle}>
        <Typography className={classes.titleText}>Add Fare model</Typography>
        <IconButton aria-label="close" onClick={handleModalClose} className={classes.closeButton}>
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        {/* Top Controls Row */}
        <Box className={classes.topControlsRow}>
          <Box className={classes.topControlsLeft}>
            {/* Service Type Select */}
            <Box className={classes.serviceTypeSelect}>
              <Typography className={classes.fieldLabel}>Service Type</Typography>
              <TextField
                name="servicetypes"
                id="servicetypes"
                select
                value={formik?.values?.servicetypes}
                onChange={formik.handleChange}
                error={Boolean(formik?.errors?.servicetypes && formik?.touched?.servicetypes)}
                helperText={formik?.touched?.servicetypes && formik?.errors?.servicetypes}
                fullWidth
                variant="outlined"
                size="small"
                className={classes.inputShape}
              >
                {servicedetails.map((service) => (
                  <MenuItem key={service.serviceName} value={service._id} style={{ fontSize: 12 }}>
                    {service.serviceName}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            {/* Surge Hour (One) Switch */}
            <Box className={classes.switchPillBox}>
              <Switch
                checked={formik.values.surgeHourone === true}
                onChange={(e) => formik.setFieldValue("surgeHourone", e.target.checked)}
                className={classes.redSwitch}
                sx={{
                  '& .MuiSwitch-switchBase': {
                    // Styles when UNCHECKED (Error state)
                    color: 'error.main',
                    '& + .MuiSwitch-track': {
                      backgroundColor: 'error.main',
                      opacity: 0.3,
                    },
                    // Styles when CHECKED (Success state)
                    '&.Mui-checked': {
                      color: 'success.main',
                      '& + .MuiSwitch-track': {
                        backgroundColor: 'success.main',
                        opacity: 0.5,
                      },
                    },
                  },
                }}
              />
              <Typography className={classes.switchPillLabel}>Surge Hour (One)</Typography>
            </Box>

            {/* Surge Hour (Two) Switch */}
            <Box className={classes.switchPillBox}>
              <Switch
                checked={formik.values.surgeHourtwo === true}
                onChange={(e) => formik.setFieldValue("surgeHourtwo", e.target.checked)}
                className={classes.redSwitch}
                sx={{
                  '& .MuiSwitch-switchBase': {
                    // Styles when UNCHECKED (Error state)
                    color: 'error.main',
                    '& + .MuiSwitch-track': {
                      backgroundColor: 'error.main',
                      opacity: 0.3,
                    },
                    // Styles when CHECKED (Success state)
                    '&.Mui-checked': {
                      color: 'success.main',
                      '& + .MuiSwitch-track': {
                        backgroundColor: 'success.main',
                        opacity: 0.5,
                      },
                    },
                  },
                }}
              />
              <Typography className={classes.switchPillLabel}>Surge Hour (Two)</Typography>
            </Box>
          </Box>

          {/* Active Status Switch */}
          <Box className={classes.switchPillBox}>
            <Typography className={classes.activeStatusLabel}>ACTIVE STATUS</Typography>
            <Switch
              checked={formik.values.isActive === true}
              onChange={(e) => formik.setFieldValue("isActive", e.target.checked)}
              className={classes.greenSwitch}
            />
          </Box>
        </Box>

        {/* Tariff Columns (Side-by-Side) */}
        <Grid container spacing={2.5}>
          {/* MONDAY - THURSDAY TARIFF */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.sectionTitleHeader}>
              <b>MONDAY - THURSDAY TARIFF</b>
            </Typography>
            <Box className={classes.sectionHeaderDivider} />

            <Box className={classes.subHeaderRow}>
              <Typography className={classes.subHeaderText}>DAY TIME SETTINGS</Typography>
              <Typography className={classes.subHeaderText}>NIGHT TIME SETTINGS</Typography>
            </Box>

            <Grid container spacing={1.5}>
              {/* Starting Time */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Starting Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("daystartingtime", formik.values.daystartingtime)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightstartingtime", formik.values.nightstartingtime)}</Grid>
                </Grid>
              </Grid>

              {/* Ending Time */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Ending Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("dayendingtime", formik.values.dayendingtime)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightendingtime", formik.values.nightendingtime)}</Grid>
                </Grid>
              </Grid>

              {/* Base Price */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("daybaseprice")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightbaseprice")}</Grid>
                </Grid>
              </Grid>

              {/* Distance Price / KM */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Distance Price / KM ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("daydistanceprice")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightdistanceprice")}</Grid>
                </Grid>
              </Grid>

              {/* Minute Price / Min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Minute Price / Min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("dayminuteprice")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightminuteprice")}</Grid>
                </Grid>
              </Grid>

              {/* Free Trip Waiting per min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Free Trip Waiting per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("FreeTripWaitingMinuteday")}</Grid>
                  <Grid item xs={6}>{renderTextField("FreeTripWaitingMinutenight")}</Grid>
                </Grid>
              </Grid>

              {/* Waiting Price / Min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Waiting Price / Min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("WaitingPriceperminday")}</Grid>
                  <Grid item xs={6}>{renderTextField("WaitingPriceperminnight")}</Grid>
                </Grid>
              </Grid>

              {/* Free Stop Waiting Price */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Free Stop Waiting Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("FreeStopsWaitingperminday")}</Grid>
                  <Grid item xs={6}>{renderTextField("FreeStopsWaitingperminnight")}</Grid>
                </Grid>
              </Grid>

              {/* Stop Waiting Price per min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Stop Waiting Price per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("StopWaitingPriceperminday")}</Grid>
                  <Grid item xs={6}>{renderTextField("StopWaitingPriceperminnight")}</Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* FRIDAY - SUNDAY TARIFF */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.sectionTitleHeader}>
              <b>FRIDAY - SUNDAY TARIFF</b>
            </Typography>
            <Box className={classes.sectionHeaderDivider} />

            <Box className={classes.subHeaderRow}>
              <Typography className={classes.subHeaderText}>DAY TIME SETTINGS</Typography>
              <Typography className={classes.subHeaderText}>NIGHT TIME SETTINGS</Typography>
            </Box>

            <Grid container spacing={1.5}>
              {/* Starting Time */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Starting Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("daystartingtimeWeekend", formik.values.daystartingtimeWeekend)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightstartingtimeWeekend", formik.values.nightstartingtimeWeekend)}</Grid>
                </Grid>
              </Grid>

              {/* Ending Time */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Ending Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("dayendingtimeWeekend", formik.values.dayendingtimeWeekend)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightendingtimeWeekend", formik.values.nightendingtimeWeekend)}</Grid>
                </Grid>
              </Grid>

              {/* Base Price */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("daybasepriceWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightbasepriceWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Distance Price / KM */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Distance Price / KM ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("daydistancepriceWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightdistancepriceWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Minute Price / Min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Minute Price / Min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("dayminutepriceWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightminutepriceWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Free Trip Waiting per min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Free Trip Waiting per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("FreeTripWaitingMinutedayWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("FreeTripWaitingMinutenightWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Waiting Price / Min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Waiting Price / Min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("WaitingPricepermindayWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("WaitingPriceperminnightWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Free Stop Waiting Price */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Free Stop Waiting Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("FreeStopsWaitingpermindayWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("FreeStopsWaitingperminnightWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Stop Waiting Price per min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Stop Waiting Price per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("StopWaitingPricepermindayWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("StopWaitingPriceperminnightWeekend")}</Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Surge Based Fare Sections */}
          <Grid item xs={12} md={6} style={{ marginTop: 12 }}>
            <Typography className={classes.sectionTitleHeader}>
              Surge based fare Surge Hour (One)
            </Typography>
            <Box className={classes.sectionHeaderDivider} />

            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Starting Time :</Typography>
                {renderTimePicker("surgeHouronestartingTime", formik.values.surgeHouronestartingTime)}
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Ending Time :</Typography>
                {renderTimePicker("surgeHouroneendingTime", formik.values.surgeHouroneendingTime)}
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Percentage :</Typography>
                {renderTextField("surgeHouronepercentage")}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={6} style={{ marginTop: 12 }}>
            <Typography className={classes.sectionTitleHeader}>
              Surge based fare Surge Hour (Two)
            </Typography>
            <Box className={classes.sectionHeaderDivider} />

            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Starting Time :</Typography>
                {renderTimePicker("surgerHourtwostartingTime", formik.values.surgerHourtwostartingTime)}
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Ending Time :</Typography>
                {renderTimePicker("surgerHourtwoendingTime", formik.values.surgerHourtwoendingTime)}
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Percentage :</Typography>
                {renderTextField("surgerHourtwopercentage")}
              </Grid>
            </Grid>
          </Grid>

          {/* Bottom Action Buttons */}
          <Grid item xs={12}>
            <Box className={classes.actionButtonsContainer}>
              <Button
                variant="outlined"
                className={classes.closeButtonAction}
                onClick={handleModalClose}
              >
                Close
              </Button>
              <Button
                variant="contained"
                className={classes.submitButtonAction}
                onClick={formik?.handleSubmit}
              >
                Add Zone Fare model
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default Servicetypecreate;
